export enum THEME_CUSTOM_COMPONENT {
  HEADER = 'customHeader',
  FOOTER = 'customFooter',
}
